import React from 'react';
export function Navbar() {
  const scrollToAgent = () => {
    const element = document.getElementById('agent');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-brand-black/80 backdrop-blur-md border-b border-brand-gold/30 px-4 md:px-12 lg:px-24 py-3 md:py-4 flex justify-between items-center" data-id="element-60">
      <div className="w-[100px] h-[34px] md:w-[120px] md:h-[40px] bg-brand-grey/20 border border-brand-grey/20 flex items-center justify-center flex-shrink-0" data-id="element-61">
        <span className="font-mono text-[9px] md:text-[10px] text-brand-grey/50 uppercase tracking-label" data-id="element-62">
          Logo
        </span>
      </div>
      <button onClick={scrollToAgent} className="border border-brand-gold text-brand-gold bg-transparent px-4 py-2.5 md:px-6 md:py-3 font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] md:tracking-label rounded-none hover:bg-brand-gold hover:text-brand-black active:bg-brand-gold active:text-brand-black transition-colors duration-300 flex-shrink-0" data-id="element-63">
        Contact Agent
      </button>
    </nav>;
}